import * as actions from "store/actions";
import { config } from "config";
import { NOTIFICATION_STATUS } from "App/componentsConfig";

function adminSocket() {
  console.log(config);
  const wsConnection = new WebSocket("wss://pns.idrivemirror.com/IDriveMirrorPNS/websocketendpoint", [
    "web.idrivemirror.com-admin-token",
  ]);

  console.log("admin=====>", wsConnection);

  wsConnection.onopen = () => {
    console.log("Admin socket opened!");
  };

  wsConnection.onmessage = (event) => {
    console.log(event);
  };

  wsConnection.onclose = (e) => {};

  wsConnection.onerror = (e) => {
    console.log("Socket connection error ===>" + e);
  };

  //   function wsConnect() {
  //     adminSocket(dispatch, state);
  //   }

  // return { wsConnection, wsConnect };
  return { wsConnection };
}

export default adminSocket;
